export default {
  // 中文配置
  in_game_label: 'InGame',
  // 注：站点切换
  english_label: 'English',
  international_remark: 'International',
  simplified_chinese_label: '简体中文',
  china_site_remark: '中国站',

  product_document_title: '产品文档',

  // 区域
  european_label_type: '欧洲(法兰克福)',
  asian_label_type: '亚太(新加坡)',
  north_label_type: '北美(弗吉尼亚)',
  east_label_type: '中国(上海)',
  woa_label_type: 'Woa',
  dev_cloud_label_type: 'DevCloud(南京)',
  idc_label_type: 'IDC(南京)',

  account_label: '账户管理',
  sign_out_label: '退出登录',
  download_center: '下载中心',

  create_title_success_desc: '你已经成功创建了一个新游戏',
  creation_fail_try: '创建失败。请重试',
  exceed_limit_10: '超过10个的上限限制',
  use_least_10: '请使用最少10个字符',
  max_72: '最大限制72个字符',
  no_different_password: '新旧密码之间没有区别',
  use_correct_email_format: '请使用正确的邮箱格式',
  incorrect_format: '错误的格式',
  no_spaces: '无空格',
  required: '必要',
  field_type_message: '字段类型 {{type}}',
  field_length_message: '字段长度不能超过 {{maxLen}}',
  please_stronger_password: '请设置更复杂的密码。尝试混合使用字母、数字和符号',
  new_title: '新游戏',
  new_title_form_label: '游戏',
  code_name_form_label: '游戏代号',
  please_enter_title_name: '请输入你的游戏名称',
  please_enter_code_name: '请输入你的游戏代号',
  region_is_required: '主站是必填的',
  code_is_required:
    '仅支持大小写字母与数字组合，不能以数字开头，不含空格且长度不超过 9 个字符',
  please_select_the_region: '请选择主站',
  region_default_env_desc: '您选择的主站是此游戏的默认环境部署主站',
  title_unique_code: '该游戏唯一标识，一旦创建不支持修改',
  message_center: '消息中心',
  view_more: '查看更多',
  type_something_search: '输入要搜索的内容',
  to_navigate: '导航',
  to_select: '选择',
  results: '结果',
  no_result: '无结果',
  search_ellipsis: '查找中...',
  search_ingame_docs: '搜索InGame文档',
  dev_portal: '开发者门户',
  account_center: '账户中心',
  back_to_studio: '返回工作室',

  // 消息-除去config.ts
  notifications_as_read: '通知已读.',
  no_unread_notifications: '无未读通知',
  notice_type: '通知',
  mark_as_read: '标记为已读',
  un_reads: '未读',

  studio_name_and_id: '{{studioStr}}',
  owner_transfer_notification_content:
    '该工作室的Owner角色已经发生转移，您现在的角色是{{authority}}。',
  permission_change_content: '您在该工作室的权限发生变更。',
  permission_change_become_admin_content:
    '您在该工作室的权限发生变更，您现在的角色是Admin。',
  action_added_type: '加入',
  action_removed_type: '移出',
  permission_change_user_groups_content:
    '您已于{{changeDate}}被{{action}}用户组"{{groups}}"。具体信息请访问组织管理页面查看。',
  group_permission_change_content:
    '您所在的用户组"{{groups}}"的权限已于{{changeDate}}发生变更。具体信息请访问组织管理页面查看。',
  group_scope_change_content:
    '您所在的用户组"{{groups}}"的生效范围已于{{changeDate}}发生变更。具体信息请访问组织管理页面查看。',
  permission_studio_delete_content:
    '我们遗憾地通知您，您的工作室{{studioName}}已于{{deletionDate}}被删除，您已经被自动移出该工作室，详情请咨询工作室Owner。',
  permission_game_delete_content:
    '我们遗憾地通知您，您所在用户组的游戏{{gameName}}已于{{deletionDate}}被删除。具体信息请访问组织管理页面查看。',
  permission_env_delete_content:
    '我们遗憾地通知您，您所在用户组的环境{{envName}}已于{{deletionDate}}被删除。具体信息请访问组织管理页面查看。',
  // update_authority_message:
  //   '请注意，您在工作室 {{studioStr}} 中的权限角色已变更，现已更新为： {{authority}}',
  the_applicant: 'The applicant, ',
  // applicant_request_message: 'The applicant, {{applicant}} ({{applicantUserID}}), has submitted a request to join the organization. The reason provided for the application is as follows: {{reason}}.',
  has_join_organization_reason_desc1:
    '您所在的{{studioStr}}工作室收到了申请者{{applicant}} ({{applicantUserID}})提交的加入申请。',
  has_join_organization_reason_desc2: '申请理由如下：',
  go_to_join_organization_page_handle: '请前往组织管理界面处理。',
  application_approved_message:
    '{{studioStr}}工作室已同意您的加入请求。现在可以进行相关操作。',
  application_rejected_message:
    '{{studioStr}}工作室已拒绝您的加入请求。如对此结果有疑问，可以联系该工作室成员。',
  regret_inform_remove_message:
    '您已被移出{{studioStr}}工作室，如对此结果有疑问，可以联系该工作室成员。',
  admin_invite_member_success:
    '您被邀请加入{{studioStr}}工作室 ，现在可以进行相关操作。',
  success_exited_studio: '您已经成功退出{{studioStr}}工作室',
  respect_user: '尊敬的用户，',
  service_open_success_inform1:
    '我们很高兴地通知您，您在 {{gameName}} / {{envName}} 环境下申请开通 {{serviceName}}  服务的审批现已通过审核。您团队现在可以全面体验该服务功能。',
  service_open_success_inform2:
    '如在使用过程中有任何疑问或需要进一步帮助，请随时与我们联系。',
  service_open_success_inform3: '祝您使用愉快！',
  service_open_fail_inform1:
    '我们很遗憾地通知您，您在 {{gameName}} / {{envName}} 环境下申请开通 {{serviceName}} 服务的审批现已被拒绝。',
  service_open_fail_inform2:
    '如对此次审批结果有任何疑问或需要进一步帮助，请随时与我们联系。',
  demo_test: '演示测试',
  company_authentication_success_content:
    '该工作室的企业认证已经审批通过。具体信息请访问工作室/基础信息页面查看。',
  company_authentication_fail_content:
    '我们遗憾地通知您，该工作室的企业认证未通过。具体信息请访问工作室/基础信息页面查看。',
  account_balance_warm:
    '截止{{createTime}}，您的账号余额低于设置的余额预警阈值。如果账户进入欠费状态，将会影响平台功能正常使用，请及时充值或注意备份数据，以免影响您的正常操作。',

  service_apply_inner_service:
    '{{GameName}} / {{EnvName}} 环境下 {{ServiceName}}',
  service_apply_pending_content:
    '尊敬的InGame用户： <br />感谢提交以下的服务申请: <br /> {{content}} <br />我们已经收到对应请求，预计将于48小时内完成服务部署与审批，感谢您的耐心等待！',
  service_apply_reject_content:
    '尊敬的用户， <br />我们很遗憾地通知您，您以下服务审批现已被拒绝。<br /> {{content}} <br />如对此次审批结果有任何疑问或需要进一步帮助，请随时与我们联系。',
  service_apply_success_content:
    '尊敬的用户，<br />我们很高兴地通知您，您以下服务审批现已通过审核。<br /> {{content}} <br />您团队现在可以全面体验该服务功能。<br />如在使用过程中有任何疑问或需要进一步帮助，请随时与我们联系。<br /祝您使用愉快！',
};
